import { StatisticalAnalysisContentScrollTable, StatisticalAnalysisExternalListTypes, StatisticalAnalysisViewDetailTableGroupingColumns } from '@/modules/statistical-analysis-module/shared/models/shared.model'

export enum StatisticalAnalysisSampleTagsStatisticsDossierGroupColumnsEnum {
    CASE_TYPE = 'CASE_TYPE',
    REGIME = 'REGIME',
    PRIORITY = 'PRIORITY',
    PATHOLOGIST = 'PATHOLOGIST',
    SAMPLE_TYPE = 'SAMPLE_TYPE',
    CASE_OF_REFERENCE = 'CASE_OF_REFERENCE',
    PHYSICIAN_HEALTH_MANAGEMENT_AREA = 'PHYSICIAN_HEALTH_MANAGEMENT_AREA',
    PHYSICIAN_CENTER = 'PHYSICIAN_CENTER',
    PHYSICIAN_DEPARTMENT = 'PHYSICIAN_DEPARTMENT',
    PHYSICIAN_PETITIONER = 'PHYSICIAN_PETITIONER',
    TOPOGRAPHIC_CODE = 'TOPOGRAPHIC_CODE',
    PROCEDURE = 'PROCEDURE',
    MOST_LIKELY_MORPHOLOGIC_CODE = 'MOST_LIKELY_MORPHOLOGIC_CODE',
    SAMPLE_TAG = 'SAMPLE_TAG'
}

export enum StatisticalAnalysisSampleTagsStatisticsDossierGroupRequestEnum {
    // TODO Pending to revision
    SAMPLE_TYPE = 'SAMPLE_TYPE',
    PATHOLOGIST = 'PATHOLOGIST',
    RESPONSIBLE_REGROSSING = 'RESPONSIBLE_REGROSSING',
    PROCEDURE = 'PROCEDURE',
    SAMPLE_PROCESS = 'SAMPLE_PROCESS',
    COMPETENCE = 'COMPETENCE',
    MOST_LIKELY_MORPHOLOGIC_CODE = 'MOST_LIKELY_MORPHOLOGIC_CODE',
    PHYSICIAN_HEALTH_MANAGEMENT_AREA = 'PHYSICIAN_HEALTH_MANAGEMENT_AREA',
    PHYSICIAN_CENTER = 'PHYSICIAN_CENTER',
    PHYSICIAN_UNIT = 'PHYSICIAN_UNIT'
}

export interface StatisticalAnalysisSampleTagsStatisticsDossierBaseRequest {
    startDate: string,
    endDate: string,
    laboratoryUserId: number
    laboratoryIds: number[],
    groupByCase: boolean
    grossedOrProcessed: boolean
    stateIds: string[]
}

export interface StatisticalAnalysisSampleTagsStatisticsDossierSamplesResponseTag {
    active: boolean
    color: string
    id: number
    name: string
}

export interface StatisticalAnalysisSampleTagsStatisticsDossierSamplesResponseTags {
    percent: number
    sampleTag: StatisticalAnalysisSampleTagsStatisticsDossierSamplesResponseTag
    total: number
}

export interface StatisticalAnalysisSampleTagsStatisticsDossierSamplesResponse {
    tagged: number
    total: number
    tags: StatisticalAnalysisSampleTagsStatisticsDossierSamplesResponseTags[]
}

export interface StatisticalAnalysisSampleTagsStatisticsDossierDetailRequest {
    groupByFields: string[]
}

export interface StatisticalAnalysisSampleTagsStatisticsDossierGroupRequest {
    groupBy1: StatisticalAnalysisSampleTagsStatisticsDossierGroupRequestEnum
    groupBy2: StatisticalAnalysisSampleTagsStatisticsDossierGroupRequestEnum
}

export interface StatisticalAnalysisSampleTagsStatisticsDossierDetailViewChartResponseInternalGroups {
    name: string
    count: number
}

export interface StatisticalAnalysisSampleTagsStatisticsDossierDetailViewChart {
    groupBy1: string
    groupBy2: StatisticalAnalysisSampleTagsStatisticsDossierDetailViewChartResponseInternalGroups[]
}

export interface StatisticalAnalysisSampleTagsStatisticsDossierDetailViewTableContentCase {
    caseOfReference: StatisticalAnalysisViewDetailTableGroupingColumns
    caseType: StatisticalAnalysisViewDetailTableGroupingColumns
    mostLikelyMorphologicCode: StatisticalAnalysisViewDetailTableGroupingColumns
    pathologist: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianCenter: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianDepartment: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianHealthManagementArea: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianPetitioner: StatisticalAnalysisViewDetailTableGroupingColumns
    priority: StatisticalAnalysisViewDetailTableGroupingColumns
    procedure: StatisticalAnalysisViewDetailTableGroupingColumns
    regime: StatisticalAnalysisViewDetailTableGroupingColumns
    sampleTag: StatisticalAnalysisViewDetailTableGroupingColumns
    sampleType: StatisticalAnalysisViewDetailTableGroupingColumns
    topographicCode: StatisticalAnalysisViewDetailTableGroupingColumns
    totalCases: number
    totalSamples: number
}

export interface StatisticalAnalysisSampleTagsStatisticsDossierDetailViewTable {
    content: StatisticalAnalysisSampleTagsStatisticsDossierDetailViewTableContentCase[]
    scrollPage: StatisticalAnalysisContentScrollTable
}

export interface StatisticalAnalysisSampleTagsStatisticsDossierDetailExternalViewTable {
    content: StatisticalAnalysisExternalListTypes[]
    scrollPage: StatisticalAnalysisContentScrollTable
}
